import { geoTypeLabel } from '@/Enums/Geography/GeographyType.enum';
import { PRIMARY } from '@/constants/color';
import { MAP_SCALES } from '@/constants/geo';
import { MenuItem, Select, outlinedInputClasses, selectClasses } from '@mui/material';
import PropTypes from 'prop-types';

const GeoChip = ({ onChange, mapScales, value, disabled = false }) => {
  const active = [
    MAP_SCALES.STATE,
    MAP_SCALES.ZIP,
    MAP_SCALES.COUNTY,
    MAP_SCALES.DMA,
    MAP_SCALES.CONGRESSIONAL_DISTRICTS,
    MAP_SCALES.CITY,
  ].includes(value);
  return (
    <Select
      onChange={e => onChange(e?.target?.value)}
      value={active ? value : ''}
      displayEmpty
      renderValue={() => 'Geo'}
      disabled={disabled}
      sx={[
        {
          height: '34px',
          borderRadius: '32px',
          fontSize: 14,
          fontWeight: 600,
          color: '#2E2C34',
        },
        active && {
          [`& .${outlinedInputClasses.notchedOutline}`]: {
            border: 'none',
          },
          border: 'none',
          color: 'white',
          backgroundColor: PRIMARY,
          [`& .${selectClasses.icon}`]: {
            color: 'white',
          },
        },
      ]}
    >
      {mapScales?.map((scale, i) => (
        <MenuItem key={i} value={scale}>
          {geoTypeLabel(scale)}
        </MenuItem>
      ))}
    </Select>
  );
};

GeoChip.propTypes = {
  onChange: PropTypes.func,
  value: PropTypes.string,
  mapScales: PropTypes.array,
  disabled: PropTypes.bool,
};

export default GeoChip;
